// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2RHNj","footer":"ModalUpdate_footer__2NmVU"};